import { createUseStyles } from "react-jss";
import TypographyDefault from "./TypographyDefault.style";
import { ITheme } from "../../../store/slices/theme";

export const useStyles = createUseStyles((theme: ITheme) => {
  const textStyle = TypographyDefault;

  return {
    root: {
      fontFamily: "Poppins",
      fontWeight: "400",
      fontStyle: "normal",
      letterSpacing: "0px",
      margin: 0,
      color: theme.colors.TextDefault,
      "&.lines-1": {
        overflow: "hidden",
        display: "-webkit-box",
        "-webkit-line-clamp": 1,
        "-webkit-box-orient": "vertical",
      },
      "&.lines-2": {
        overflow: "hidden",
        display: "-webkit-box",
        "-webkit-line-clamp": 2,
        "-webkit-box-orient": "vertical",
      },
      "&.lines-3": {
        overflow: "hidden",
        display: "-webkit-box",
        "-webkit-line-clamp": 3,
        "-webkit-box-orient": "vertical",
      },

      // Color of text
      "&.default": { color: theme.colors.TextDefault },
      "&.error": { color: theme.colors.NotificationError },
      "&.secondary": { color: theme.colors.TextSecondary },
      "&.silver": { color: theme.colors.TextSilver },
      "&.gray": { color: theme.colors.TextGray },
      "&.disable": { color: theme.colors.TextDisable },
      "&.charcoal": { color: theme.colors.TextCharcoal },
      "&.graphite": { color: theme.colors.TextGraphite },

      // ===========================================================
      // Font style, decoration, size, line height
      // ===========================================================
      ...textStyle,
    },
  };
});
